import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { TextModule } from '@library/ui/atoms/text/text.module';

@Component({
  selector: 'app-toolbar-select-item',
  imports: [
    TextModule,
    IconModule,
  ],
  templateUrl: './toolbar-select-item.component.html',
  styleUrl: './toolbar-select-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarSelectItemComponent {
  label = input.required<string>();
  selected = input.required<boolean>();

  select = output();
}
